<template>

  <div class="landing">

   <div class="section" id="landing">
        <h5 id="mainText" class="center">My Name Is</h5>
        <h1 style="color: white;"  class="center">
            MIKE <b>TAYLOR</b>
        </h1>
        <h6 id="mainText" class="center">Web Developer living in Columbus Ohio</h6>
</div>

<!-- <div class="fixed-action-btn vertical">
    <a class="btn-floating btn-large  blue-grey darken-4">
        <i class="fa fa-globe">globe</i>
    </a>
    <ul>
      
        <li><a class="btn-floating  blue darken-4"><i class="fa fa-facebook">cloud</i></a></li>
        <li><a class="btn-floating cyan lighten-1"><i class="fa fa-twitter">a</i></a></li>
        <li><a class="btn-floating grey darken-3"> <i class="fa fa-github"></i></a></li>
        <li><a class="btn-floating blue-grey lighten-1"><i class="fa fa-linked-in"></i></a></li>
    </ul>
</div> -->


<!-- <div class="fixed-action-btn click-to-toggle">
  <a class="btn-floating btn-large red">
      <i class="material-icons">menu</i>
  </a>
  <ul>
      <li>
          <a class="waves-effect waves-light btn-floating social google"><i class="fa fa-linked-in">cloud</i></a>
      </li>
      <li>
          <a class="waves-effect waves-light btn-floating facebook"><i class="fa fa-facebook">globe</i></a>
      </li>
      <li>
          <a class="waves-effect waves-light btn-floating github"><i class="fa fa-github">cloud</i></a>
      </li>
  </ul>
</div> -->
       


<!-- Intro and service -->
<div id="intro" class="section black">
    <div class="container">
        <div class="row">
            <div  class="col s12">
                <h2 class="center header"> About Me</h2>
            </div>
        </div>
        <div class="row center">
            <div class="col s12 m12 l3">
                <img class="responsive-img" src="../assets/mike.jpg">
            </div>
            <dic class="col s12 m12 offset-l1 l8 ">
                <h5 class="center">Mike Taylor </h5>
                <p>
                   I am a web developer with experience in front end and full stack web applications. I have nearly 12 years in the IT Support field, however I am looking to make the switch into software engineering . I am fueled by my passion for exploring the world of coding. I consider myself a ‘forever student,’ eager to both build on my foundations in software and stay in tune with the latest advances through continued coursework and professional development. I am currently looking for a software engineering position and am interested in any type of challenge in the field.
                    <br />
                    <i>“Creativity is intelligence having fun” -Albert Einstein </i> 
                </p>
            </dic>
        </div>
    </div>

<!--Work-->
<div class="section" style="background-color: #141414; background-image: url('https://i.pinimg.com/originals/1e/ef/c5/1eefc5567dc5c55f67ef6849b9235582.jpg'); " id="work">
    <div class="container">
        <h3 class="header text_b center">My Projects </h3>
        <div class="row ">
            <div class="col s12 m12 l4">

                <div class="card hoverable black">

                    <div class="card-image waves-effect waves-block waves-light">
                        <a href="https://mikes-friends.web.app/" target="_blank"><img class="activator" src="https://helpdeskgeek.com/wp-content/pictures/2019/08/gpx-to-google-maps-main.jpg.optimal.jpg"></a>
                    </div>
                    <div class="card-content">
                        <span class="card-title activator purple-text text-lighten-5"><a href="https://mikes-friends.web.app/">Mike's Friend Locater</a><i class="mdi-navigation-more-vert right"></i></span>
                        
                    </div>
                    <div>
                      
                        <p class="card-content">This app uses the Google Maps API to grab your current location and display it on a map. It also shows you locations of previous users of the app. You can then click on the google marker
                          of any user and write a message to them. Requires you to create an account using the sign up page.<br>Written in Vue and Firebase
                        </p>
                    </div>
                    </div>
                 
                
                
            </div>          
            


                  <div class="col s12 m12 l4">

                <div class="card hoverable black">

                    <div class="card-image waves-effect waves-block waves-light">
                       <a class="purple-text" href="https://mikeyt-chat.web.app/" target="_blank"> <img class="activator" src="https://www.kayako.com/blog/assets/live-chat-for-better-customer-experiences-970x582.png"></a>
                    </div>
                    <div class="card-content">
                        <span class="card-title activator purple-text text-lighten-5"><a class="purple-text" href="https://mikeyt-chat.web.app/" target="_blank">Live Chat Room App</a><i class="mdi-navigation-more-vert right"></i></span>
                        
                    </div>
                    <div>
                        <p class="card-content">Are you bored with WhatsApp, Slack or regular old text messaging? Well look no further! MikeyT chat is the new cool way to chat with friends! <br>Written in Vue and Firebase</p>
                    </div>

                    
                    </div>

                    
                
                  

                
            </div>   

             <div class="col s12 m12 l4">

                <div class="card hoverable black">

                    <div class="card-image waves-effect waves-block waves-light">
                       <a class="purple-text" href="https://ninja-smoothies-c4fe7.firebaseapp.com/" target="_blank"> <img class="activator" src="https://www.the-learning-agency.com/uploads/1/1/7/3/117316733/when-should-our-students-use-technology-for-note-taking_orig.jpg"></a>
                    </div>
                    <div class="card-content">
                        <span class="card-title activator purple-text text-lighten-5"><a class="purple-text" href="https://ninja-smoothies-c4fe7.firebaseapp.com/" target="_blank">Recipe Taking App</a><i class="mdi-navigation-more-vert right"></i></span>
                        
                    </div>
                    <div>
                        
                        <p class="card-content">Add/Edit drink recipes. This app is using a Firebase backend so check back on the recipes whenever you would like! Written in Vue and Firebase</p>
                    </div>
                    </div>
                  </div>   

                     <div class="col s12 m12 l4">

                <div class="card hoverable black">

                    <div class="card-image waves-effect waves-block waves-light">
                        <a class="purple-text" href="https://dice-arena.web.app/" target="_blank"><img class="activator" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcT9s_BGgRbt0YEDjfClRHvfV7bUc0AphkNbnA&usqp=CAU"></a>
                    </div>
                    <div class="card-content">
                        <span class="card-title activator purple-text text-lighten-5"><a class="purple-text" href="https://dice-arena.web.app/" target="_blank">Dice Arena</a><i class="mdi-navigation-more-vert right"></i></span>
                        
                    </div>
                    <div>
                        
                        <p class="card-content">A web app to roll Dice! Perfect for game night!<br> Written in Vue</p>
                    </div>
                    </div>
                  </div>   
                    
                    
                  

                
           

             <div class="col s12 m12 l4">

                <div class="card hoverable black">

                    <div class="card-image waves-effect waves-block waves-light">
                        <a class="purple-text" href="https://world-of-wordcraft.herokuapp.com/" target="_blank"><img class="activator" src="https://www.rd.com/wp-content/uploads/2019/12/book-e1576790089347.jpg"></a>
                    </div>
                    <div class="card-content">
                        <span class="card-title activator purple-text text-lighten-5"><a class="purple-text" href="https://world-of-wordcraft.herokuapp.com/" target="_blank">World of Wordcraft</a><i class="mdi-navigation-more-vert right"></i></span>
                       
                    </div>
                    <div>
                        <p class="card-content">This app takes any body of text that you add to the input box and displays the top N most used words(N being a user selected value). You can remove a word from the list and the next highest
                          used word will slide in. You can also get synonyms with an API call to Merriam-Webster's Thesaurus.<br>Written in Angular and hosted on Heroku
                        </p>
                    </div>
                    </div>
                 </div>   
                    
                  

                
                                 

                
        </div>

        
    </div>
    
</div>
<div id="contact" class="section black">
    <div class="container">
        <div class="row">
            <!-- <div  class="col s12"> -->
                <h2 class="center header"> Contact</h2>
            </div>
             <dic class="col s12 m12 offset-l1 l8 ">
                
                <ul class="center">
                  <li><i class="material-icons"></i><a href="https://github.com/mikejtaylor22" target="_blank" class="git">&nbsp; Github </a></li>
                  <li><i class="social fa fa-facebook"></i><a href="https://www.linkedin.com/in/michael-taylor-2ab99667/" target="_blank" class="linked">LinkedIn</a></li>
                  <li><i class="fa fa-google-plus"></i><a href="https://mail.google.com" target="_blank" class="goog">&nbsp; mikejtaylor22@gmail.com </a></li>
                    
                </ul>
            </dic>
        <!-- </div> -->
    </div>
    </div>
</div>



  </div>
</template>

<script>

export default {
  name: 'Landing',
  data () {
    return {
      
    }
  }
}
</script>


<style>
#landing{
    height: 100vh;
    background-image: url('https://i.pinimg.com/originals/1e/ef/c5/1eefc5567dc5c55f67ef6849b9235582.jpg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    z-index: -1;
}
#mainText{
    margin-top: 30vh;
}

a {
  color:blueviolet;
}
.linked {
 color: rgb(40,103,178);

}
.goog{
  color:red;
}

.activator img {
  max-width: 200px;
  max-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue